/**
 * AUTH zhaikai
 * 配置系统右侧菜单
 * icon图标，没有
 * link：路由地址
 * name:标题
 * childrens:子菜单
 * 可配置一个参数 true或者false来显示是否有子菜单 目前没做此功能
 *
 */
export default [
  {
    name: 'HOME',
    lang_key: 'home',
    type: true,
    icon: 'icon-home',
    test_id: 'menu_homepage',
    link: '/home',
    childrens: []
  },
  {
    name: 'MY ACCOUNT',
    lang_key: 'my_accout',
    icon: 'icon-my-accout',
    test_id: 'menu_my_account',
    childrens: [
      {
        name: 'ACCOUNT INFO',
        lang_key: 'account_info',
        link: '/account-info',
        test_id: 'menu_account_info',
        childrens: []
      },
      // {
      //   name: 'OTHER ACCOUNT',
      //   lang_key: 'otherAccount',
      //   link: '/other-account',
      //   test_id: 'menu_otherAccount',
      //   childrens: []
      // },
      {
        name: 'RECORDS',
        lang_key: 'records',
        link: '/records',
        test_id: 'menu_records',
        childrens: []
      },
      // {
      //   name: 'SUB ACCOUNT',
      //   lang_key: 'subAccount',
      //   link: '/sub-account',
      //   test_id: 'menu_subAccount',
      //   childrens: []
      // },
      // {
      //   name: 'TRADE PRODUCT',
      //   lang_key: 'tradeProduct',
      //   link: '/trade-product',
      //   test_id: 'menu_tradeProduct',
      //   childrens: []
      // },
      // {
      //   name: 'TRADE PRODUCT',
      //   lang_key: 'quotes',
      //   link: '/quotes',
      //   test_id: 'menu_quotes',
      //   childrens: []
      // },
      {
        name: 'TABLE DOWNLOAD',
        lang_key: 'table-download',
        link: '/table-download',
        test_id: 'menu_tabledownload',
        childrens: []
      }
      // {
      //   name: 'SETTING',
      //   lang_key: 'setting',
      //   link: '/setting',
      //   test_id: 'menu_setting_page',
      //   childrens: []
      // }
    ]
  },
  {
    name: 'DEPOSIT',
    lang_key: 'deposit',
    icon: 'icon-deposit',
    link: '/deposit',
    // id: 'menu-deposit',
    class: 'deposit-li',
    test_id: 'menu_deposit',
    childrens: []
  },
  // {
  //   name: 'WITHDRAWAL',
  //   lang_key: 'withdrawal',
  //   icon: 'icon-widhdrawal',
  //   link: '/withdrawal',
  //   class: 'withdrawal-li',
  //   test_id: 'menu_withdraw',
  //   childrens: []
  // },
  // {
  //   name: 'INTERNAL TRANSFER',
  //   lang_key: 'internal_transfer',
  //   icon: 'icon-internal-transfer',
  //   link: '/fund-transfer',
  //   test_id: 'menu_transfer',
  //   childrens: []
  // },
  // {
  //   name: 'EXCHANGE',
  //   lang_key: 'exchange',
  //   icon: 'icon-currency',
  //   link: '/exchange',
  //   test_id: 'menu_transfer',
  //   childrens: []
  // },
  {
    name: 'DOWNLOAD',
    lang_key: 'download',
    icon: 'icon-download',
    link: '/download',
    test_id: 'menu_download',
    childrens: []
  },
  {
    name: 'LOGOUT',
    lang_key: 'logout',
    icon: 'icon-logout',
    link: '/logout',
    test_id: 'menu_logout',
    childrens: []
  }
]
